import {isNoU} from "./DBUtils";

export const matchBy = (behavior, collection) => {
    let matchMap = {};
    let fromField = behavior.matchFields.from;
    let toField = behavior.matchFields.to;

    for (let item of collection) {
        let resource = item.resource;
        let itemFrom = resource[fromField];
        let itemTo = resource[toField];

        // Check if there is a match first
        if (!isNoU(matchMap[itemTo])) {
            matchMap[itemTo].push(item);
        } else {
            // No match, make entry to be matched
            matchMap[itemFrom] = [];
            matchMap[itemFrom].push(item);
        }
    }

    console.log(matchMap);

    let result = matchMap;
    switch (behavior.use) {
        case "first":
            result = Object.keys(matchMap).map((item) => matchMap[item][0]);
            break;
    }

    return result;
};

export const displayOrderSort = (item1, item2) => {
    let item1Order = item1.displayOrder || -1;
    let item2Order = item2.displayOrder || -1;

    return item1Order - item2Order;
};


// WEBPACK FOOTER //
// ./public/utils/collectionManagmentUtils.js